import { CampaignOutlined, EventOutlined, ArticleOutlined, ChatOutlined, ConnectWithoutContact, Groups, VideoCall, FlightTakeoff, ReceiptLong,Feedback, EmojiEventsOutlined, WorkspacePremium } from '@mui/icons-material';
import { Stack, Typography, Tooltip, Grid, IconButton, Box, Paper, useMediaQuery } from '@mui/material';
import React from 'react';
import { variants } from '../../../variants/variants';
import { useLocation, useNavigate } from 'react-router-dom';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useTheme } from '@emotion/react';
import BackButton from '../../../common/BackButton';
import NavbarLayout from '../../../common/NavbarLayout';
import { useDispatch } from 'react-redux';
import { toggleOutlet } from '../announcementSlice';
import { webview } from '../../../app/api/webview';
import { iframe } from '../../WebView/components/MobileView';
import { setIframeMessage } from '../../WebView/webviewSlice';

const announcementsItems = {
  board: { title: 'Pings', subtitle: 'Your Central Hub for Announcements', icon: CampaignOutlined, path: 'board' },
  leave: { title: 'Leave', subtitle: 'Manage and Track Leaves', icon: EventOutlined, path: 'leave' },
  gnn: { title: 'GNN',  icon: ArticleOutlined, path: 'gnn' },
  chats: { title: 'Chats',  icon: ChatOutlined, path: 'chats' },
  gnnDetails: { title: 'News Details', icon: ArticleOutlined,  path: 'gnnDetails/:id' },
  feedback: {
    title: 'Feedback',
    subtitle: 'Reach out to developers',
    icon: Feedback,
    path: 'feedback',
  },

  gatewaybox: {
    title: 'Gateway Box',
    subtitle: 'Unified Access to Gateway Apps',
    icon: WidgetsOutlinedIcon,
    path: 'gatewaybox',
  },
  connect: {
    title: 'Connect',
    subtitle: 'Network and collaborate effectively',
    icon: ConnectWithoutContact,
    path: 'gatewaybox',
  },
  conference: {
    title: 'Conference',
    subtitle: 'Book a conference room',
    icon: Groups,
    path: 'gatewaybox',
  },
  meeting: {
    title: 'Meeting',
    subtitle: 'Seamless virtual meeting solution',
    icon: VideoCall,
    path: 'gatewaybox',
  },
  travel: {
    title: 'Travel',
    subtitle: 'Assistance for your travel bookings',
    icon: FlightTakeoff,
    path: 'gatewaybox',
  },
  reimbursement: {
    title: 'Reimbursement',
    subtitle: 'Claim your expenses with ease',
    icon: ReceiptLong,
    path: 'gatewaybox',
  },
  leave: {
    title: 'Leave',
    subtitle: 'Request and manage your time off',
    icon: EventOutlined,
    path: 'gatewaybox',
  },
  Archivement: {
    title: 'Wall of Achievements',
    subtitle: 'Celebrate achievements and milestones',
    icon: EmojiEventsOutlined,
    path: 'gatewaybox',
  },
  CertificateWall: {
    title: 'Certification Wall',
    subtitle: 'Celebrate achievements and milestones',
    icon: WorkspacePremium,
    path: 'gatewaybox',
  },
};

const AnnouncementNavbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const { pathname } = useLocation();
  const path = isMobile ? (pathname.split('/')[3]=="gbox" ? ((pathname.includes('wall-of-achievements') ||pathname.includes('certificate-wall') ) ? (pathname.includes('certificate-wall') ? "CertificateWall" : 'Archivement') : pathname.split('/')[pathname.split('/').length-1].split('-')[0]) : (pathname.includes('wall-ofachievements') )? 'Archivement' : pathname.split('/')[3]) : (pathname.includes('wall-ofachievements') ? 'Archivement' : pathname.split('/')[3]);
  // const path = isMobile ? pathname.split('/')[pathname.split('/').length-1].split('-')[0] : pathname.split('/')[3];
  const currentNavigation = announcementsItems[path];
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  const handleNavigateBack = () => {
    if (path == 'gnnDetails') {
      window['ReactNativeWebView']?.postMessage(
        JSON.stringify({ type: 'backClicked', data:true })
      );
    navigate('/home/announcement/gnn')
    return
    }
    else if (path == 'CertificateWall') {
      navigate('/home/announcement/gbox/wall-of-achievements')
      return
    }
    else{
      if (path == 'leave') {

        window['ReactNativeWebView'] &&
        window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'webview', value: "leave module close" }));
      }
      // if(path == 'reimbursement'){
      //   dispatch(setIframeMessage({action:"triggerClick"}))
      //   return
      // }
      dispatch(toggleOutlet(false))
      navigate('/home/announcement/gatewaybox')
      return
    }
  }
  if (!currentNavigation) {
    return null;
  }

  const IconComponent = currentNavigation.icon;

  return (
    <NavbarLayout handleNavigate={handleNavigateBack}>
    <Grid item display={'flex'} justifyContent={'start'} alignItems={'center'}>
      <Tooltip title={currentNavigation.title}>
        <IconComponent sx={variants.icon.active} />
      </Tooltip>
      <Typography component={'div'} ml={1} sx={{ fontSize: variants.BODY }}>
        {currentNavigation.title}{' '}
        <Typography
          sx={{
            fontSize: variants.BODY,
            [theme.breakpoints.down('lg')]: {
              fontSize: variants.TINY,
            },
          }}
        >
          {currentNavigation.subtitle}
        </Typography>
      </Typography>
      
    </Grid>
    </NavbarLayout>
  );
};

export default AnnouncementNavbar;
